import { z } from "zod";
import { RequestPartnerAddressDtoSchema } from "./RequestPartnerAddressDto";
import { RequestContractVehiclesDtoSchema } from "./RequestContractVehiclesDto";

export const RequestHelperGetContractPrepopInfoOutputSchema = z.object({
    contractOdvetvieId: z.number().nullish(),
    contractAddress: RequestPartnerAddressDtoSchema.nullish(),
    contractVehicles: z.array(RequestContractVehiclesDtoSchema),
    clientEmail: z.string().nullish(),
});

export type RequestHelperGetContractPrepopInfoOutput = z.infer<typeof RequestHelperGetContractPrepopInfoOutputSchema>;